import { object, string } from 'yup';

import { passwordsMatchValidator } from '@utils/validation';

import { validationErrMessages } from '@constants/validationConstants';

export const schema = object({
	currentPassword: string()
		.trim()
		.default('')
		.required(validationErrMessages.password),
	newPassword: string()
		.trim()
		.default('')
		.required(validationErrMessages.password),
	confirmPassword: string()
		.trim()
		.default('')
		.required(validationErrMessages.password)
		.test('passwords-match', validationErrMessages.passwordMatch, passwordsMatchValidator),
});
